import axios from 'axios';
import Cookies from 'js-cookie';
import { routes } from '../../conf/routes';

axios.defaults.xsrfHeaderName = 'X-CSRFTOKEN';
axios.defaults.xsrfCookieName = 'csrftoken';

function replaceUrlParams(path, urlParams) {
  return path.replace(/:(\w+)/gi, (_, captured) => urlParams[captured] || '')
    .replace('.localhost/', `.localhost:${window.location.port || '8000'}/`);
}

export function processUrl(apiPath) {
  const url = `${window.location.protocol}//${window.location.host}`;
  return `${url}/${routes[apiPath]}`;
}

export function processParamsUrl(apiPath, urlParams = {}) {
  const url = processUrl(apiPath);
  return replaceUrlParams(url, urlParams);
}

export function apiFetcher(requestParams) {
  const { apiPath, urlParams } = requestParams;
  const fullUrl = processParamsUrl(apiPath, urlParams);

  const headers = {
    ...requestParams.headers,
    'X-XSRF-TOKEN': Cookies.get('csrftoken'),
  };

  return axios({
    headers,
    url: fullUrl,
    method: requestParams.method,
    data: requestParams.data,
    params: requestParams.params,
  });
}

export default apiFetcher;
